var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrintPage',[_c('TaskPageHeader1',{attrs:{"day":_vm.day}}),_c('TaskList',{attrs:{"tasks":_vm.day.tasks}}),_c('div',{staticStyle:{"display":"flex","justify-content":"center","padding-top":"10px","color":"#bdbdbd"}},[_vm._v(_vm._s(_vm.taskBook.info.motto))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }